import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store'
import { routerReducer } from '@ngrx/router-store'
import { appReducer } from './app.reducer'
import { environment } from '../../../environments'
import { loadingReducer } from './loading.reducer'
import { IGlobalState } from '../global.state'
import { storageReducer } from './storage.reducer'
import { notificationsEntityReducer } from './notificaitons.reducer'
import { financeOverviewReducer } from '@adex/store/reducers/finance-overview.reducer'
import { financeExpensesReducer } from '@adex/store/reducers/finance-expensis.reducer'


export const reducers: ActionReducerMap<IGlobalState> = {
  appState: appReducer,
  loadingState: loadingReducer,
  storageState: storageReducer,
  routerState: routerReducer,
  notificationsState: notificationsEntityReducer,
  financeOverviewState: financeOverviewReducer,
  financeExpensesState: financeExpensesReducer
}

export function logger(reducer: ActionReducer<IGlobalState>): ActionReducer<IGlobalState> {
  return (state: IGlobalState, action: any): IGlobalState => reducer(state, action)
}

export const metaReducers: MetaReducer<IGlobalState>[] = !environment.production ? [ logger ] : []
